export const DOCUMENT_NUMBER_FILED_NAME = 'documentNumber';
export const DOCUMENT_PLACE_DATE = 'documentPlaceDate';
export const DOCUMENT_EXPIRE_DATE = 'documentExpireDate';
export const DOCUMENT_PLACE = 'documentPlace';
export const DOCUMENT_TYPE_ID = 'documentTypeId';
